<div class="row" [sxc-toolbar]>
  @if (showSideNav$ | async) {
    <!-- Show User Navigation -->
    <div class="col-md-2">
      <div class="user-col">
        <div class="user">
          <a [routerLink]="['/', routesConst.home]" class="initials">
            {{ authSvc.authentication().user.Initials }}
          </a>
          <div class="name">{{ authSvc.authentication().user.FirstName }} {{ authSvc.authentication().user.LastName }}</div>
          <ul>
            <li>
              <a [routerLink]="['/', routesConst.myProfile]" [ngClass]="{ active: checkActiveUrl(routesConst.myProfile) }"> My Profile </a>
            </li>
            <li>
              <a [routerLink]="['/', routesConst.companyProfile]" [ngClass]="{ active: checkActiveUrl(routesConst.companyProfile) }"> My Company Profile </a>
            </li>

            @if (authSvc.authentication().user.ShowUserManagement) {
              <li>
                <a [routerLink]="['/', routesConst.manageUsers]" [ngClass]="{ active: checkActiveUrl(routesConst.manageUsers) }"> User Management </a>
              </li>
            }

            @if (authSvc.authentication().user.AllowImpersonation) {
              <li>
                <a [routerLink]="['/', routesConst.impersonation]" [ngClass]="{ active: checkActiveUrl(routesConst.impersonation) }"> Impersonation </a>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
  <div [class.col-md-10]="showSideNav$ | async" [class.col-md-12]="!(showSideNav$ | async)">
    <router-outlet></router-outlet>
  </div>
</div>
